/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  revenueComparisonLine:{
    analyticsData: {
      thisMonth: 0,
      lastMonth: 0
    },
    series: [
      {
        name: 'This Month',
        data: [0]
      },
      {
        name: 'Last Month',
        data: [0]
      }
    ]
  },
  revenueComparisonLine2:{
    analyticsData: {
      thisMonth: 0,
      lastMonth: 0
    },
    series: [
      {
        name: 'This Month',
        data: [0]
      },
      {
        name: 'Last Month',
        data: [0]
      }
    ]
  },
  revenueComparisonLine3:{
    analyticsData: {
      thisMonth: 0,
      lastMonth: 0
    },
    series: [
      {
        name: 'This Month',
        data: [0]
      },
      {
        name: 'Last Month',
        data: [0]
      }
    ]
  },
  revenueComparisonLine4:{
    analyticsData: {
      thisMonth: 0,
      lastMonth: 0
    },
    series: [
      {
        name: 'This Month',
        data: [0]
      },
      {
        name: 'Last Month',
        data: [0]
      }
    ]
  },
  withdraw: {
    total:0,
    success:0,
    all:0,
  },
  deposit:{
    bonus:0,
    bonustotal:0,
  },
  deposit30:[{
    name: 'ฝาก',
    data: []
  }],
  withdraw30:[{
    name: 'ถอน',
    data: []
  }],
  active30:[{
    name: 'ผู้ใช้',
    data: []
  }],
  bonus30:[{
    name: 'Bonus',
    data: []
  }],
  usersactive:{
    active:0,
    total:0,
  },
  users:[],
  krungsri:{
    total:0,
    success:0,
    all:0,
  },
  firstcredit:{
    total:0,
    count:0,
  },
  firstcreditNew:{
    total:0,
    count:0,
  },
  firstcreditOld:{
    total:0,
    count:0,
  },
  cache:{},
}
